module.exports = __webpack_public_path__ + "static/media/rambarde.28754e8d.jpg";